export default function($log) {
  'ngInject';

  const vm = this;

  vm.$onInit = activate;

  function setStyling(status) {
    const styles = {
      attended: {
        borderColor: 'panel-primary',
        textColor: 'text-primary',
        text: 'You have already completed this course'
      },
      completed: {
        borderColor: 'panel-primary',
        textColor: 'text-primary',
        text: 'You have already completed this course'
      },
      declined: {
        borderColor: 'panel-muted',
        textColor: 'text-muted',
        text: 'This invitation has been',
        subText: 'Declined',
        subTextStyling: 'bold'
      },
      registered: {
        borderColor: 'panel-success',
        textColor: 'text-success',
        text: 'Your Registration is',
        subText: 'Confirmed',
        subTextStyling: 'bold'
      },
      waitlisted: {
        borderColor: 'panel-warning',
        textColor: 'text-warning',
        text: 'This event is at capacity.',
        textStyling: 'bold',
        subText: 'You’ve been added to the waitlist and will be notified if your registration is confirmed.'
      }
    };

    vm.alert = styles[status];
  }

  function activate() {
    $log.debug('Firm Invites CTRL Activated');

    setStyling(vm.ngModel.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alertsCtrl/alerts/product/controller.js